/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCommentsAlt} from '@fortawesome/pro-duotone-svg-icons';

const ConferencesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCommentsAlt} {...props} />
);

export default ConferencesIcon;
